import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Sitemap = () => {
  const sections = [
    {
      title: 'Intelligence',
      id: 'intelligence',
      icon: FiIcons.FiCpu,
      description: 'Neural mood analysis and psychological profiling'
    },
    {
      title: 'Workspace',
      id: 'workspace',
      icon: FiIcons.FiGrid,
      description: 'Color picker, tools, and brand fit analysis'
    },
    {
      title: 'Personality',
      id: 'personality',
      icon: FiIcons.FiUserCheck,
      description: 'Match colors to brand personality archetypes'
    },
    {
      title: 'Discovery',
      id: 'discovery',
      icon: FiIcons.FiCompass,
      description: 'Explore swatches and industry-specific palettes'
    },
    {
      title: 'Theory',
      id: 'theory',
      icon: FiIcons.FiBookOpen,
      description: 'Color psychology and emotion gallery'
    },
    {
      title: 'Insights',
      id: 'insights',
      icon: FiIcons.FiBarChart2,
      description: 'E-commerce statistics and CTA color theory'
    }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="mt-20 mb-12">
      <div className="flex items-center gap-3 mb-8">
        <span className="h-0.5 w-10 bg-blue-500" />
        <h3 className="text-sm font-bold text-blue-400 uppercase tracking-wider font-display">
          Site Navigation
        </h3>
      </div>
      
      <div className="glass-panel p-8 md:p-12 rounded-3xl border border-white/10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sections.map((section) => (
            <button
              key={section.id}
              onClick={() => scrollToSection(section.id)}
              className="text-left p-6 bg-white/[0.03] hover:bg-white/[0.06] rounded-2xl border border-white/[0.08] hover:border-white/20 transition-all group"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500/20 transition-colors">
                  <SafeIcon icon={section.icon} className="text-blue-400 text-xl" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-base font-bold text-white mb-2 group-hover:text-blue-400 transition-colors font-display">
                    {section.title}
                  </h4>
                  <p className="text-xs text-gray-400 leading-relaxed font-body">
                    {section.description}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
        
        <div className="mt-8 pt-8 border-t border-white/[0.08]">
          <p className="text-xs text-gray-500 text-center font-body">
            Quick navigation to all sections • 
            <a href="https://color-intelligence.sheker.com" className="text-blue-400 hover:text-blue-300 ml-1">
              color-intelligence.sheker.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Sitemap;